
    import {computed, ComputedRef, defineComponent, reactive, onMounted, toRefs} from 'vue';
    import {useStore} from "@/store";
    import swiperComponent from "@/views/idlefish/components/swiperComponent.vue";

    interface Tab {
        name: string;
        num: number;
        id: string;
        photoList: Array<any>;
    }

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        clientHeight: number; // 当前视窗高度
        modelName: string; // 车型名称
        listTab: Array<Tab>; // 照片类型分组
        actTab: string; // 当前查看照片分组id
        photoList: Array<Photo>; // 当前展示的照片列表
        isShowSwiper: boolean; // 是否展示轮播图组件
        backFun: string; // 导航返回点击方法
        swiperPhotoList: Array<Photo>; // 展示轮播图时的照片合集
        initialSlideSwiper: number; // 设定初始化时slide的索引
        initialSlideAll: number;
        isAll: boolean;
    }

    export default defineComponent({
        name: "photoListAll",
        props: {
            backFun: {
                type: String,
                default: ''
            },
            initialSlide: {
                type: Number,
                default: 0
            }
        },
        setup(props: any) {
            let state: State = reactive({
                clientHeight: 0,
                modelName: '',
                listTab: [
                ],
                actTab: 'basePhoto',
                photoList: [],
                isShowSwiper: true,
                backFun:'',
                swiperPhotoList: [],
                initialSlideSwiper: 0,
                initialSlideAll: 0,
                isAll: false
            })
            
            const store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            
            const {photoList, paintPhotoList, markPhotoList, defectPhotoList, modelName} = dataInfo.value as any
            // 展示轮播图时的照片合集（一期基本照片20210810）
            if (photoList && photoList.length > 0) {
                state.listTab.push({
                    name: '基本照片',
                    id: 'basePhoto',
                    num: 0,
                    photoList: photoList
                })
                let len = photoList.length;
                let imgList: Array<any> = [];
                photoList.forEach((item, index) => {
                    let obj = {
                        bigPhotoUrl: item.bigPhotoUrl,
                        hasBindDefect: item.hasBindDefect,
                        label: `${index + 1}/${len}`,
                        originPhotoPath: item.originPhotoPath,
                        photoCode: item.photoCode,
                        photoFrontType: item.photoFrontType,
                        photoFrontTypeName: item.photoFrontTypeName,
                        photoId: item.photoId,
                        photoIdStr: item.photoIdStr,
                        photoName: item.photoName,
                        photoPath: item.photoPath,
                        photoType: item.photoType,
                        remark: item.remark,
                        smallPhotoUrl: item.smallPhotoUrl,
                    };
                    imgList.push(obj);
                });
                state.swiperPhotoList = state.swiperPhotoList.concat(imgList);
            }
            if (paintPhotoList && paintPhotoList.length >0) {
                state.listTab.push({
                    name: '漆面照片',
                    id: 'paintPhoto',
                    num: 0,
                    photoList: paintPhotoList
                })
                let len = paintPhotoList.length;
                let imgList: Array<any> = [];
                paintPhotoList.forEach((item, index) => {
                    let obj = {
                        bigPhotoUrl: item.bigPhotoUrl,
                        hasBindDefect: item.hasBindDefect,
                        label: `${index + 1}/${len}`,
                        originPhotoPath: item.originPhotoPath,
                        photoCode: item.photoCode,
                        photoFrontType: item.photoFrontType,
                        photoFrontTypeName: item.photoFrontTypeName,
                        photoId: item.photoId,
                        photoIdStr: item.photoIdStr,
                        photoName: item.photoName,
                        photoPath: item.photoPath,
                        photoType: item.photoType,
                        remark: item.remark,
                        smallPhotoUrl: item.smallPhotoUrl,
                    };
                    imgList.push(obj);
                });
                state.swiperPhotoList = state.swiperPhotoList.concat(imgList);
            }
            if (markPhotoList && markPhotoList.length > 0) {
                state.listTab.push({
                    name: '留痕照片',
                    id: 'markPhoto',
                    num: 0,
                    photoList: markPhotoList
                })
                let len = markPhotoList.length;
                let imgList: Array<any> = [];
                markPhotoList.forEach((item, index) => {
                    let obj = {
                        bigPhotoUrl: item.bigPhotoUrl,
                        hasBindDefect: item.hasBindDefect,
                        label: `${index + 1}/${len}`,
                        originPhotoPath: item.originPhotoPath,
                        photoCode: item.photoCode,
                        photoFrontType: item.photoFrontType,
                        photoFrontTypeName: item.photoFrontTypeName,
                        photoId: item.photoId,
                        photoIdStr: item.photoIdStr,
                        photoName: item.photoName,
                        photoPath: item.photoPath,
                        photoType: item.photoType,
                        remark: item.remark,
                        smallPhotoUrl: item.smallPhotoUrl,
                    };
                    imgList.push(obj);
                });
                state.swiperPhotoList = state.swiperPhotoList.concat(imgList);
            }
            if (defectPhotoList) {
                state.listTab.push({
                    name: '瑕疵照片',
                    id: 'defectPhoto',
                    num: 0,
                    photoList: defectPhotoList
                })
                let len = defectPhotoList.length;
                let imgList: Array<any> = [];
                defectPhotoList.forEach((item, index) => {
                    let obj = {
                        bigPhotoUrl: item.bigPhotoUrl,
                        hasBindDefect: item.hasBindDefect,
                        label: `${index + 1}/${len}`,
                        originPhotoPath: item.originPhotoPath,
                        photoCode: item.photoCode,
                        photoFrontType: item.photoFrontType,
                        photoFrontTypeName: item.photoFrontTypeName,
                        photoId: item.photoId,
                        photoIdStr: item.photoIdStr,
                        photoName: item.photoName,
                        photoPath: item.photoPath,
                        photoType: item.photoType,
                        remark: item.remark,
                        smallPhotoUrl: item.smallPhotoUrl,
                    };
                    imgList.push(obj);
                });
                state.swiperPhotoList = state.swiperPhotoList.concat(imgList);
            }
            // title展示文字
            state.modelName = modelName;
            // 整理照片列表
            state.listTab.forEach((item: any) => {
                if (item.id === 'basePhoto') {
                    item.photoList = photoList;
                    item.num = photoList.length;
                    state.photoList = photoList;
                }
                if (item.id === 'paintPhoto') {
                    item.photoList = paintPhotoList && paintPhotoList !== null ? paintPhotoList : [];
                    item.num = paintPhotoList && paintPhotoList !== null ? paintPhotoList.length : 0;
                }
                if (item.id === 'markPhoto') {
                    item.photoList = markPhotoList && markPhotoList !== null ? markPhotoList : [];
                    item.num = markPhotoList && markPhotoList !== null ? markPhotoList.length : 0;
                }
                if (item.id === 'defectPhoto') {
                    item.photoList = defectPhotoList && defectPhotoList !== null ? defectPhotoList : [];
                    item.num = defectPhotoList && defectPhotoList !== null ? defectPhotoList.length : 0;
                }
            })
            function changeType(tab: string) {
                if (state.actTab === tab) {
                    return
                }
                state.actTab = tab
            }
            function toTab(index: number){
                let res = 0;
                let sumList: number[] = [0]
                for (let i = 0; i < state.listTab.length; i++) {
                    let listTab = state.listTab[i]
                    if (i === 0) {
                        sumList.push(listTab.num)
                    } else {
                        let num = listTab.num + sumList[i]
                        sumList.push(num)
                    }
                }
                for (let i = 0; i < sumList.length; i++) {
                    if (index + 1 > sumList[i]) {
                        res = i
                    }
                }
                const newId = (state.listTab[res] as any).id
                if (newId !== state.actTab) {
                    changeType(newId)
                }
            }
            // 获取当前设备高度用于设置黑色背景高度
            onMounted(() => {
                const {initialSlide} = toRefs(props);
                state.initialSlideAll =  initialSlide;
                state.initialSlideSwiper = state.initialSlideAll;
                toTab(state.initialSlideAll);
                state.clientHeight = document.documentElement.clientHeight;
            })
            return {
                state,
                toTab,
                changeType
            }
        },
        methods: {
            /**
             * 点击切换照片分类
             * */
            changeActTab(tab: string) {
                // 切换照片分类
                this.changePhotoType(tab);
                if (this.state.isShowSwiper) {
                    let index = 0
                    for (let i = 0; i < this.state.listTab.length; i++) {
                        let item = this.state.listTab[i]
                        if (tab === (item as any).id) {
                            for (let j = 0; j < this.state.swiperPhotoList.length; j++) {
                                let jtem = this.state.swiperPhotoList[j];
                                if (jtem.photoIdStr === item.photoList[0].photoIdStr) {
                                    index = j;
                                    break
                                }
                            }
                            break
                        }
                    }
                    this.state.initialSlideSwiper = index
                }
            },
            /**
             * 轮播图切换事件
             * */
            slideChange(data: any) {
                const {index} = data;
                let res = 0;
                let sumList: number[] = [0]
                for (let i = 0; i < this.state.listTab.length; i++) {
                    let listTab = this.state.listTab[i]
                    if (i === 0) {
                        sumList.push(listTab.num)
                    } else {
                        let num = listTab.num + sumList[i]
                        sumList.push(num)
                    }
                }
                for (let i = 0; i < sumList.length; i++) {
                    if (index + 1 > sumList[i]) {
                        res = i
                    }
                }
                const newId = (this.state.listTab[res] as any).id
                if (newId !== this.state.actTab) {
                    this.changePhotoType(newId)
                }
            },
            /**
             * 切换照片分类
             * */
            changePhotoType(tab: string) {
                if (this.state.actTab === tab) {
                    return
                }
                this.state.actTab = tab
            },
            goPhoto() {
                this.$emit('allPhont', this.state.isAll)
            },
            goBack() {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                let _this =this;
                if (_this.backFun) {
                    _this.$emit(_this.backFun)
                } else {
                    history.go(-1)
                }
                // history.go(-1)
            }
        },
        components: {
            swiperComponent
        }
    })
